"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_AUDITS = void 0;
var client_1 = require("@apollo/client");
exports.DELETE_AUDITS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation AdminDeleteAudits($input: BulkDeleteInput!) {\n    deleteAudits(input: $input) {\n      deleted\n    }\n  }\n"], ["\n  mutation AdminDeleteAudits($input: BulkDeleteInput!) {\n    deleteAudits(input: $input) {\n      deleted\n    }\n  }\n"])));
var templateObject_1;
